import styled, { css } from 'styled-components';

import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';

import { Box } from '../Box';

export const FindAStore = styled(Flex)<{ findAStoreColor: string }>`
  flex: 1;
  height: 100%;
  align-items: center;
  &:last-child {
    margin-right: 0;
  }
  flex-direction: column;
  ${({ findAStoreColor, theme }) => css`
    background: ${findAStoreColor ?? theme.colors.secondaryLightGrey};
    margin-right: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
      display: flex;
      margin-right: 12px;
      flex-direction: row;
    }
  `}
`;

export const NoResultBoutiqueInfo = styled(Box)`
  flex: 1;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  ${({ theme }) => css`
    margin-right: ${theme.spacing(2)};
  `}
`;

export const NoResultImage = styled(Box)`
  min-height: 257px;
  width: 100%;
  position: relative;
  img {
    object-fit: cover;
  }
  .error > img {
    position: absolute;
    top: 50%;
  }
  flex: 2;
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      min-height: 400px;
    }
  `}
`;

export const NoResultInfoBox = styled(Flex)`
  flex: 1;
  height: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacing(3)};
    text-align: center;
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.spacing(1.7)};
    line-height: ${theme.spacing(2.8)};
    @media (min-width: ${theme.breakpoints.sm}) {
      padding: ${theme.spacing(0, 6)};
      text-align: left;
    }
  `}
`;

export const NoResultIcon = styled(Icon)`
  text-align: left;
  line-height: 17px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h4};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.primary};
  `}
`;

export const NoResultCTA = styled(Flex)`
  align-items: start;
  flex-direction: column;
  width: 100%;
`;

export const NoResultButton = styled(Button)`
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  padding: 12.5px 0;
  ${({ theme }) => css`
    color: ${theme.colors.navyBlueSub1};
    background: ${theme.colors.primary};
    font-family: ${theme.fontFamilies.openSans};

    margin-top: ${theme.spacing(2)};
    border: 2px solid ${theme.colors.primary};
    @media (min-width: ${theme.breakpoints.sm}) {
      width: 178px;
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;

export const PlaceholderStoresCard = styled(Flex)<{ findAStoreColor: string }>`
  height: 100%;
  min-height: 480px;
  align-items: center;
  &:last-child {
    margin-right: 0;
  }

  width: 100%;
  ${({ findAStoreColor, theme }) => css`
    background: ${findAStoreColor ?? theme.colors.secondaryLightGrey};
    margin-right: ${theme.spacing(2)};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      overflow: hidden;
      display: flex;
      margin-right: 12px;
    }
  `}
`;

export const PlaceholderStoresImage = styled(Box)`
  width: 100%;
  min-height: 245px;
  position: relative;
  img {
    object-fit: cover;
  }
  .error > img {
    position: absolute;
    top: 50%;
  }
`;

export const PlaceholderStoresInfoBox = styled(Flex)`
  width: 100%;
  height: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacing(3, 2)};
    font-size: ${theme.spacing(1.5)};
    line-height: ${theme.spacing(2.2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      padding: ${theme.spacing(3, 2, 2.5, 2)};
      font-size: ${theme.spacing(1.7)};
      line-height: ${theme.spacing(2.3)};
    }
  `}
`;

export const PlaceholderStoresButton = styled(Button)`
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  padding: 12.5px 0;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.openSans};

    margin-top: ${theme.spacing(2)};
    border: 2px solid ${theme.colors.primary};
    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;
